module.exports = __webpack_public_path__ + "img/megafono.0a1cf6a4.svg";